<template>
  <div class="new">
    <div class="Reference">
      <!-- <div class="hl-info" @click="$router.push({ name: 'chemotherapy' })">
      参考文献
      <i class="iconfont icon-right_medium"></i>
    </div> -->
      <ReferContent :dataList="dataList" />
    </div>
  </div>
</template>
<script>
import ReferContent from "@/components/openClose/ReferContent.vue";
import {Reference} from "@/api/reportQuery";
import { mapState } from "vuex";
export default {
  components: {
    ReferContent,
  },
  data(){
    return {
      dataList: [],

    }
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$nextTick(async () => {
        try {
          let { data } = await Reference({
            labOriginalSampleNo: this.$route.query.fname,
            productId: this.$route.query.fid,
          });
          this.dataList = data;
          console.log(this.dataList,'22222222')
        } catch (error) {}
      });
    },
  },
  
};
</script>
<style lang="less" scoped>
.new{
  padding: 20px;
}
.Reference {
  margin-bottom: 20px;
  background: @background_color;
  border-radius: 10px;
  padding-top: 20px;
  .hl-info {
    height: 70px;
    font-size: 18PX;
    padding: 0 24px;
    font-weight: 500;
    color: #2f354d;
    line-height: 70px;
    background: @background_color;
    border-radius: 10px;
    i {
      float: right;
    }
  }
}
</style>
